/**
 * REL-24 — the ruled ASC products, the ONE client-side source of truth.
 *
 * These strings must match App Store Connect exactly (product ids are
 * PERMANENT there) and must match the server's allowlist in
 * `api/lib/storekit-verify.js`. A node test pins the two lists against each
 * other, so drift fails the gate rather than the purchase.
 *
 * ⛔ NO PRICES HERE, BY RULING. $12.99 / $129.99 are what ASC is configured
 * with, but the buy surface shows Apple's localized `displayPrice` from
 * StoreKit — a hardcoded price would be wrong in every storefront but one, and
 * wrong everywhere the day the founder reprices.
 *
 * Order is display order: monthly first.
 */

export const STOREKIT_PRODUCT_IDS = [
  'tayro.athlete.monthly.1299',
  'tayro.athlete.annual.12999',
] as const;

export type StoreKitProductId = (typeof STOREKIT_PRODUCT_IDS)[number];

/** One license (founder ruling 2026-08-19): Athlete. Family and Team are
 *  archived and are NOT sold in the app. */
export const STOREKIT_TIER = 'athlete';
